import { ApiSlugs, TokenVaultId } from '@workspace/data-types';
import { ApiCaller } from '../../api-caller.service';
import { TokenVaultsUserConnector } from './user/token-vaults-user.connector';

export class TokenVaultsConnector {
  private slug = ApiSlugs.TOKEN_VAULTS;

  constructor(
    private apiCaller: ApiCaller,
    private prefix: string,
  ) {}

  users = () => new TokenVaultsUserConnector(this.apiCaller, this.slug, this.prefix);

  tokenVault = (tokenVaultId: TokenVaultId) => {
    if (!tokenVaultId) {
      throw new Error('No tokenVaultId provided while calling API user token vault endpoint');
    }
    const tokenVaultUrl = `${this.slug}/${tokenVaultId}`;
    return {
      users: () => new TokenVaultsUserConnector(this.apiCaller, tokenVaultUrl, this.prefix),
    };
  };
}
